import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';


const initCarousels = () => {
    const elements = document.querySelectorAll('.splide');
    if(elements){
        for ( var i = 0; i < elements.length; i++ ) {
            if(elements[ i ].id === 'hero'){
                initHeroSlider(elements[ i ])
            }else{
                initCasualSlider(elements[ i ])
            }
        }
    }
}

const initCasualSlider = (element) => {
    new Splide( element , {
        drag   : 'free',
        focus  : 'center',
        autoScroll: {
            speed: 0.5,
        },
        perPage: 5,
        breakpoints: {
            0: {
                perPage: 2,
            },
            425: {
                perPage: 2,
            },
            768: {
                perPage: 3,
            },
            992: {
                perPage: 4,
            },
            1200: {
                perPage: 5
            }
        },
        mediaQuery: 'min',
    }).mount({ AutoScroll });
}

const initHeroSlider = (element) => {
    const splide = new Splide(element, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: false,    // pokud nechceš tečky
        autoplay: false,
        drag: true,
        autoHeight: true
    });


    let timeoutId = null;

    //pause autoplay (workaround for ios, has to have autoplay otherwise we can not play() before interaction on website)
    const allVideos = document.querySelectorAll('#hero video')
    if(allVideos){
        allVideos.forEach((video) => {
            try {
                video.pause()
                video.currentTime = 0;
            } catch (e) {
                console.warn('Could not set video.currentTime = 0', e);
            }
        })
    }


    function handleSlideChange() {
        if(timeoutId){
            clearTimeout(timeoutId);
            timeoutId = null;
        }

        const slide = splide.Components.Slides.getAt(splide.index);
        if (!slide || !slide.slide) return;

        const video = slide.slide.querySelector('video');

        if (video) {


            //lazy load
            if(video.dataset.src){
                video.setAttribute('src', video.dataset.src)
                video.removeAttribute('data-src')
            }

            //play video
            if (video.readyState < 2) {
                video.addEventListener('loadeddata', function (){
                    try {
                        video.play()
                    } catch (e) {
                        console.warn('Could not play video on loadeddata', e);
                    }
                })
            }
            else{
                try {
                    video.play()
                } catch (e) {
                    console.warn('Could not play video', e);
                }
            }


            //pause other video slides
            const allVideos = document.querySelectorAll('#hero video')
            allVideos.forEach((otherVideo) => {
                if(otherVideo !== video){
                    if(otherVideo.attributes.src){
                        try {
                            otherVideo.pause()
                            otherVideo.currentTime = 0;
                        } catch (e) {
                            console.warn('Could not set otherVideo.currentTime = 0', e);
                        }
                    }
                }
            })


            //next slide on end
            if(!video.classList.contains('ended-initialised')){
                video.classList.add('ended-initialised')
                video.addEventListener('ended', () => {
                    splide.go('+1')
                });
            }
        } else {
            //image
            timeoutId = setTimeout(() => {
                splide.go('+1')
                timeoutId = null
            }, 3000);

            //pause videos
            const allVideos = document.querySelectorAll('#hero video')
            allVideos.forEach((video) => {
                if (video.attributes.src) {
                    try {
                        video.pause()
                        video.currentTime = 0;
                    } catch (e) {
                        console.warn('Could not set otherVideo.currentTime = 0', e);
                    }
                }
            })
        }
    }

    splide.on('active', handleSlideChange);
    splide.mount();


}

export default initCarousels;